var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrow = function SvgDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.469.664a.75.75 0 1 0-.937 1.172l5 4a.75.75 0 0 0 .936 0l5-4a.75.75 0 1 0-.937-1.172L6 4.29zm0 4a.75.75 0 1 0-.937 1.172l5 4a.75.75 0 0 0 .936 0l5-4a.75.75 0 1 0-.937-1.172L6 8.29z",
    clipRule: "evenodd"
  })));
};
export default SvgDoubleArrow;